/*
 * poor man's version of joining paths with forward slashes while ensuring that there's only a single slash between segments
 * @returns a path that will always start with a leading slash and segments that are separated by a single forward slash
 */
export function joinPaths(...paths: string[]): string {
  return `/${paths.join('/')}`.replace(/\/+/g, '/');
}
